import { render } from "./MvQuiz.vue?vue&type=template&id=fa424d28&scoped=true"
import script from "./MvQuiz.vue?vue&type=script&lang=js"
export * from "./MvQuiz.vue?vue&type=script&lang=js"

import "./MvQuiz.vue?vue&type=style&index=0&id=fa424d28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa424d28"]])

export default __exports__